const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const getRequestFormFields = (form) => Array.from(form.querySelectorAll('[name="name"], [name="email"]'));

const getFieldMessage = (field) => {
	const value = field.value.trim();

	if (field.name === 'name' && !value) {
		return 'Вкажіть ваше ім\'я';
	}

	if (field.name === 'email') {
		if (!value) {
			return 'Вкажіть ваш email';
		}

		if (!emailPattern.test(value)) {
			return 'Вкажіть коректний email';
		}
	}

	return '';
};

const setFieldError = (field, message) => {
	const errorId = field.getAttribute('aria-describedby');
	const error = errorId ? document.getElementById(errorId) : null;
	const fieldWrapper = field.closest('.js-request-field');

	if (error) {
		error.textContent = message;
	}

	if (message) {
		field.setAttribute('aria-invalid', 'true');

		if (fieldWrapper) {
			fieldWrapper.classList.add('is-invalid');
		}

		return;
	}

	field.removeAttribute('aria-invalid');

	if (fieldWrapper) {
		fieldWrapper.classList.remove('is-invalid');
	}
};

const setRequestFormStatus = (requestFormStatus, message, isError = false) => {
	if (!requestFormStatus) {
		return;
	}

	requestFormStatus.textContent = message;
	requestFormStatus.classList.toggle('is-error', isError);
};

const validateRequestForm = (form) => {
	let firstInvalidField = null;

	getRequestFormFields(form).forEach((field) => {
		const message = getFieldMessage(field);

		setFieldError(field, message);

		if (message && !firstInvalidField) {
			firstInvalidField = field;
		}
	});

	if (firstInvalidField) {
		firstInvalidField.focus();
		return false;
	}

	return true;
};

const submitRequestFormAjax = async (form) => {
	const response = await fetch(window.themeVar.url, {
		method: 'POST',
		body: new FormData(form),
		headers: {
			Accept: 'application/json'
		}
	});

	if (!response.ok) {
		throw new Error('Request failed');
	}

	return response;
};

const openSuccessPopup = (successPopup, successDialog) => {
	if (!successPopup) {
		return;
	}

	successPopup.classList.add('open');
	document.body.classList.add('is-success-popup-open');

	if (successDialog) {
		successDialog.focus();
	}
};

const closeSuccessPopup = (successPopup) => {
	if (!successPopup) {
		return;
	}

	successPopup.classList.remove('open');
	document.body.classList.remove('is-success-popup-open');
};

export const initRequestForm = () => {
	const requestForm = document.querySelector('.js-request-form');
	const requestFormStatus = document.querySelector('.js-request-form-status');
	const successPopup = document.querySelector('.js-form-success');
	const successDialog = successPopup ? successPopup.querySelector('.js-form-success-dialog') : null;
	const successCloseButtons = document.querySelectorAll('.js-form-success-close');

	if (requestForm) {
		getRequestFormFields(requestForm).forEach((field) => {
			field.addEventListener('input', () => {
				setFieldError(field, getFieldMessage(field));
				setRequestFormStatus(requestFormStatus, '');
			});
		});

		requestForm.addEventListener('submit', async (event) => {
			event.preventDefault();
			setRequestFormStatus(requestFormStatus, '');

			if (!validateRequestForm(requestForm)) {
				return;
			}

			const submitButton = requestForm.querySelector('.js-request-submit');
			const submitLabel = submitButton ? submitButton.getAttribute('data-submit-label') || submitButton.textContent : '';
			const loadingLabel = submitButton ? submitButton.getAttribute('data-loading-label') || submitLabel : '';

			if (submitButton) {
				submitButton.disabled = true;
				submitButton.textContent = loadingLabel;
			}

			try {
				await submitRequestFormAjax(requestForm);
				requestForm.reset();
				getRequestFormFields(requestForm).forEach((field) => setFieldError(field, ''));
				openSuccessPopup(successPopup, successDialog);
			} catch (error) {
				setRequestFormStatus(requestFormStatus, 'Не вдалося надіслати заявку. Спробуйте ще раз.', true);
			} finally {
				if (submitButton) {
					submitButton.disabled = false;
					submitButton.textContent = submitLabel;
				}
			}
		});
	}

	successCloseButtons.forEach((button) => {
		button.addEventListener('click', () => closeSuccessPopup(successPopup));
	});
};
